import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import TouchAppIcon from '@material-ui/icons/TouchApp'

const useStyles = makeStyles({
  card: {
    minWidth: 275,
    width: 300,
    textAlign: 'center'
  },
  title: {
    fontSize: 14
  },
  pos: {
    margin: 20,
    fontSize: 48
  }
})

export default function SimpleCard() {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography
          className={classes.title}
          color="textSecondary"
          gutterBottom
        >
          Dar clic en su región para ver el presupuesto ejecutado por municipios.
        </Typography>
        <TouchAppIcon className={classes.pos} />
      </CardContent>
    </Card>
  )
}
